import React from 'react';
import { motion } from 'framer-motion';
export type MetricTone = 'sky' | 'emerald' | 'violet' | 'amber' | 'rose';
interface MetricCardProps {
  label: string;
  value: string;
  detail: string;
  badge?: string;
  tone: MetricTone;
}
const toneClasses: Record<MetricTone, {
  border: string;
  value: string;
  badge: string;
}> = {
  sky: {
    border: 'bg-sky-500',
    value: 'text-sky-700',
    badge: 'bg-sky-50 text-sky-700 ring-1 ring-inset ring-sky-200'
  },
  emerald: {
    border: 'bg-emerald-500',
    value: 'text-emerald-700',
    badge: 'bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-200'
  },
  violet: {
    border: 'bg-violet-500',
    value: 'text-violet-700',
    badge: 'bg-violet-50 text-violet-700 ring-1 ring-inset ring-violet-200'
  },
  amber: {
    border: 'bg-amber-500',
    value: 'text-amber-700',
    badge: 'bg-amber-50 text-amber-700 ring-1 ring-inset ring-amber-200'
  },
  rose: {
    border: 'bg-rose-500',
    value: 'text-rose-700',
    badge: 'bg-rose-50 text-rose-700 ring-1 ring-inset ring-rose-200'
  }
};
export function MetricCard({
  label,
  value,
  detail,
  badge,
  tone
}: MetricCardProps) {
  const styles = toneClasses[tone];
  return <motion.article initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} whileHover={{
    y: -2
  }} transition={{
    duration: 0.2
  }} className="relative overflow-hidden rounded-lg border border-slate-200 bg-white px-3.5 pb-3 pt-4 shadow-sm" data-id="element-107" data-mp="2l41ons627nn2">
      <span className={`absolute inset-x-0 top-0 h-1 ${styles.border}`} aria-hidden="true" data-id="element-108" data-mp="1xf0bxsq71qbz" />
      <p className="text-[10px] font-semibold uppercase tracking-[0.08em] text-slate-400" data-id="element-109" data-mp="1xcmkdtuq2w96">{label}</p>
      <p className={`mt-1 text-xl font-bold leading-none tracking-tight ${styles.value}`} data-id="element-110" data-mp="267alr8x6ftsp">{value}</p>
      <p className="mt-2 min-h-[16px] text-[11px] leading-4 text-slate-500" data-id="element-111" data-mp="19ped56dqhd4i">{detail}</p>
      {badge && <span className={`mt-1 inline-flex rounded px-1.5 py-0.5 text-[10px] font-semibold ${styles.badge}`} data-id="element-112" data-mp="1dqrjrionhkch">
          {badge}
        </span>}
    </motion.article>;
}